module.exports = __webpack_public_path__ + "img/logo.1aef2d69.png";